const colorStyle = {
  bg: '#FFFFFF',
  color: '#788195',
  selected: '#2b303b',
  unSelected: '#788195'
};

export const styles = {
  main: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  menuItemStyle: {
    fontSize: 14,
    color:colorStyle.unSelected,
    letterSpacing:1
  },
  menuSubStyle: {
    fontSize: 14,
    backgroundColor: colorStyle.bg,
  },
  menuItemSubHeaderStyle: {
    fontSize: 14,
    color:colorStyle.unSelected
  },
  menuItemStyleSelected: {
    fontSize: 14,
    color:colorStyle.selected
  },
  menuItemSubStyleSelected: {
    fontSize: 14,
    color:colorStyle.selected,
  },
};



// WEBPACK FOOTER //
// ./src/menu/styles.js